import {
    Button, Upload,
} from 'antd';
import {RcFile} from 'antd/es/upload';
import React from 'react';

import {AIS_ROUTES} from 'components/ais/ais.constants';
import {SIGN_UPLOAD_EXTENSIONS} from 'components/ais/monitor-services-card/monitor-service-dynamic-fields/model/constants';
import {IconsMap} from 'components/dynamic-icon';
import {SignWithCryptoProModal} from 'features/sign-with-crypto-pro';
import {renameSignatureFile} from 'features/sign-with-crypto-pro/lib';
import {EFileExtensions} from 'shared/constants/file-extensions';
import {useAppSelector} from 'store/config/hooks';
import {EDocumentsSigningMethod, selectDocumentsSigningMethod} from 'store/slices/documents-uploading-slice';

interface ISignatureItemActionsProps {
  signatureName: string | undefined;
  attachmentId: string | undefined;
  attachmentFileName: string | undefined;
  isSignatureUploading: boolean;
  handleUploadFile: (file: RcFile) => boolean;
}

export const SignatureActionButton = ({
    signatureName, attachmentId, isSignatureUploading, handleUploadFile, attachmentFileName,
}: ISignatureItemActionsProps) => {
    const documentsSigningMethod = useAppSelector(selectDocumentsSigningMethod);

    return (
        <>
            {documentsSigningMethod === EDocumentsSigningMethod.UPLOAD_EDS_FILE && (
                <Upload
                    beforeUpload={handleUploadFile}
                    accept={SIGN_UPLOAD_EXTENSIONS}
                    showUploadList={false}
                    disabled={!attachmentId}
                >
                    <Button
                        type="primary"
                        loading={isSignatureUploading}
                        disabled={!attachmentId}
                    >
                        {`${signatureName ? 'Загрузить новую' : 'Загрузить'} ЭП`}
                    </Button>
                </Upload>
            )}
            {documentsSigningMethod === EDocumentsSigningMethod.CRYPTO_PRO_PLUGIN && (
                <SignWithCryptoProModal
                    attachmentIds={[attachmentId as string]}
                    entityName={AIS_ROUTES.RECLAIMING_INFORMATION}
                    handleSignedFileUpload={({signatureFile, selectedFileExtension}) => {
                        if (signatureFile) {
                            handleUploadFile(
                                attachmentFileName
                                    ? renameSignatureFile(
                                        signatureFile,
                                        attachmentFileName,
                                        selectedFileExtension!,
                                    ) as RcFile
                                    : signatureFile as RcFile,
                            );
                        }
                    }}
                    disabledFields={['signatureType', 'fileExtension', 'fileEncoding']}
                    defaultFileExtension={EFileExtensions.BIN}
                    triggerButton={(
                        <Button
                            type="primary"
                            icon={<IconsMap.SafetyCertificateOutlined />}
                            disabled={!attachmentId}
                        >
                            Подписать
                        </Button>
                    )}
                />
            )}
        </>
    );
};
